import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { GlobalMessageType, RoutingService } from '@spartacus/core'
import { finalize, switchMap } from 'rxjs/operators'
import { ShipmentAgreementHistoryStatus } from '../../../../../../models/enum/agreement.enum'
import { CustomRoutes } from '../../../../../../models/enum/custom-routes.enum'
import { SharedValue } from '../../../../../../models/enum/shared.enum'
import { IAgreement } from '../../../../../../models/interface/agreement.interface'
import { ICsv } from '../../../../../../models/interface/csv.interface'
import { IHistoryList } from '../../../../../../models/interface/history-list.interface'
import { ISharedPagination } from '../../../../../../models/interface/shared.interface'
import { DispenserAgreementService } from '../../../../../../services/agreement/dispenser/dispenser-agreement.service'
import { DispenserShipmentService } from '../../../../../../services/agreement/dispenser/dispenser-shipment.service'
import { ShipmentCreditClaimService } from '../../../../../../services/agreement/shipment-credit-claim/shipment-credit-claim.service'
import { DocumentService } from '../../../../../../services/document.service'
import { CsvService } from '../../../../../../services/shared/csv/csv.service'
import { CustomGlobalMessageService } from '../../../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../../../services/shared/shared.service'
import { ICustomSelectOption } from '../../../../../shared/custom-components/custom-select/modals/interface/custom-select.interface'
import { CustomTableColumnType } from '../../../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import {
  ICustomTableColumn,
  ICustomTableHeader
} from '../../../../../shared/custom-components/custom-table/modals/interface/custom-table.interface'

@Component({
    selector: 'app-dispenser-shipment-history',
    templateUrl: './dispenser-shipment-history.component.html',
    styleUrls: ['./dispenser-shipment-history.component.scss'],
    standalone: false
})
export class DispenserShipmentHistoryComponent implements OnInit {
  public agreementCode: string
  public agreement: IAgreement
  public entries: IHistoryList
  public showLoaderOnPagination: boolean = true
  public selectedPage: number = 1
  public selectedFilter: string
  public selectedSearch: string
  public downloadingCsv = false
  public filterOptions: ICustomSelectOption[] = Object.keys(ShipmentAgreementHistoryStatus).map((item) => {
    return {
      label: 'dispenserShipment.status.' + item,
      value: item
    }
  })

  public headers: ICustomTableHeader[] = [
    { title: 'dispenserShipment.id' },
    { title: 'dispenserShipment.date' },
    { title: 'dispenserShipment.address' },
    { title: 'dispenserShipment.type' },
    { title: 'shared.status' },
    { title: 'dispenserShipment.netValue' },
    { title: 'shared.actions', type: CustomTableColumnType.BUTTONS }
  ]

  public columns: ICustomTableColumn[] = [
    {
      key: 'code',
      type: CustomTableColumnType.LINK,
      link: {
        handler: (res) => this.viewDetails(res)
      }
    },
    { key: 'shipmentDate', type: CustomTableColumnType.DATE },
    { key: 'address.formattedAddress' },
    { key: 'type', mapWith: 'dispenserShipment.shipTo.' },
    { key: 'status', mapWith: 'dispenserShipment.status.' },
    { key: 'netValue.formattedValue' },
    {
      key: 'buttons',
      type: CustomTableColumnType.BUTTONS,
      buttons: [
        {
          title: 'shared.details',
          translate: true,
          icon: 'fa fa-info-circle',
          handler: (res) => this.viewDetails(res)
        },
        {
          key: 'downloadCreditNote',
          title: 'shared.downloadCreditNote',
          translate: true,
          icon: 'fa fa-download',
          handler: (res) => this.downloadCreditNote(res.orderDocument)
        }
      ]
    }
  ]

  constructor(
    public dispenserAgreementService: DispenserAgreementService,
    public dispenserShipmentService: DispenserShipmentService,
    public globalMessageService: CustomGlobalMessageService,
    public sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
    public routingService: RoutingService,
    protected csvService: CsvService,
    protected shipmentCreditClaimService: ShipmentCreditClaimService,
    protected documentService: DocumentService
  ) {}

  ngOnInit(): void {
    this.sharedService
      .getUrlParam('agreementCode')
      .pipe(
        switchMap((code) => {
          this.agreementCode = code
          return this.dispenserAgreementService.getAgreementDetail(code)
        })
      )
      .subscribe((detail) => {
        this.agreement = detail
        this.changeDetectorRef.detectChanges()
        this.sharedService
          .getQueryParams()
          .subscribe((queryParams) => {
            if (queryParams?.page) {
              this.pageChange(queryParams.page)
            } else {
              this.pageChange(1)
            }
          })
          .unsubscribe()
      })
  }

  public viewDetails(value: any): void {
    const queryParam = {
      [CustomRoutes.DISPENSER_AGREEMENT_SHIPMENT_HISTORY]: { page: this.selectedPage }
    }
    this.sharedService.setQueryParamsLocal(queryParam)

    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.DISPENSER_AGREEMENT_SHIPMENT_DETAILS
        //Sagar
        // }, null, {queryParams: {agreementId: this.agreementCode, shipmentId: value?.code}});
      },
      { queryParams: { agreementId: this.agreementCode, shipmentId: value?.code } }
    )
  }

  public pageChange(page: number): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.DISPENSER_AGREEMENT_SHIPMENT_HISTORY,
        params: { agreementCode: this.agreementCode }
        // Sagar
        // }, null, {queryParams: {page: page}});
      },
      { queryParams: { page: page } }
    )

    this.selectedPage = page
    this.changePageData({
      pageNumber: this.selectedPage,
      status: this.selectedFilter,
      searchText: this.selectedSearch
    })
  }

  public changePageData(params: ISharedPagination): void {
    this.showLoaderOnPagination = true
    this.dispenserShipmentService
      .getShipments(this.agreementCode, params)
      .pipe(
        finalize(() => {
          this.showLoaderOnPagination = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe((res) => {
        if (!res) {
          this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
        } else {
          this.entries = res
        }
      })
  }

  public downloadCSV(): void {
    this.downloadingCsv = true
    this.dispenserShipmentService.downloadCSV(this.agreementCode).subscribe(
      (results) => {
        const csv: ICsv = {
          title: `Shipment History`,
          columns: [
            { title: 'dispenserShipment.id', key: 'code' },
            { title: 'dispenserShipment.date', key: 'shipmentDate', type: CustomTableColumnType.DATE },
            { title: 'dispenserShipment.address', key: 'address.formattedAddress' },
            { title: 'dispenserShipment.type', key: 'type' },
            { title: 'shared.status', key: 'status' },
            { title: 'dispenserShipment.netValue', key: 'netValue.formattedValue' },
            { title: 'dispenserShipment.shipmentLineNumber', key: 'entry.entryNumber' },
            { title: 'dispenserAgreement.materialNumber', key: 'entry.product.code' },
            { title: 'dispenserAgreement.materialDescription', key: 'entry.product.name' },
            { title: 'dispenserShipment.materialStatus', key: 'entry.shipmentEntryStatus' },
            { title: 'dispenserShipment.eta', key: 'entry.namedDeliveryDate', type: CustomTableColumnType.DATE },
            { title: 'dispenserShipment.materialNetValue', key: 'entry.netValue.formattedValue' },
            { title: 'dispenserShipment.quantityIssued', key: 'entry.quantitySelected' }
          ],
          rows: this.extractEntries(results)
        }
        this.downloadingCsv = false
        this.csvService.generateCSV(csv)
        this.changeDetectorRef.detectChanges()
      },
      (err) => {
        this.downloadingCsv = false
        this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        this.changeDetectorRef.detectChanges()
      }
    )
  }

  protected extractEntries(results): any[] {
    let newItems: any[] = results.map((item) => {
      if (item.entries.length) {
        return item.entries.map((entry) => {
          return {
            ...item,
            entry: { ...entry }
          }
        })
      }
      return item
    })
    newItems = newItems.reduce((acc, item) => {
      return acc.concat(item)
    }, [])
    return newItems
  }

  public get disableWhenNoDataOrDownloading(): boolean {
    return !this.entries?.results?.length || this.downloadingCsv
  }

  public onSearch(value): void {
    this.selectedSearch = value?.trim()
    this.changePageData({
      status: this.selectedFilter,
      shipmentId: this.selectedSearch
    })
  }

  public filterChange(value: string): void {
    this.selectedFilter = value
    this.changePageData({
      status: this.selectedFilter,
      shipmentId: this.selectedSearch
    })
  }

  public get showMessageWhenNoData(): boolean {
    return !this.showLoaderOnPagination
  }

  public get showLoaderOnStartupOrWhenNoData(): boolean {
    return !this.entries?.results?.length && this.showLoaderOnPagination
  }

  public downloadCreditNote(documentId: string): void {
    if (!documentId) {
      return
    }

    this.documentService
      .getDocumentByNumber(documentId)
      .subscribe((res) => this.shipmentCreditClaimService.generateCreditNote(res))
  }
}
